import React from "react"
import {
  Col,
  Form,
  FormFeedback,
  Label,
  Row,
  Toast,
  ToastBody,
} from "reactstrap"
import Spinners from "components/Common/Spinner"
import close from "../../../assets/images/icons/close.svg"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import BgPatternImage from "../../../assets/images/background-pattern.png"

function RejectConfirmationModel({
  open,
  data,
  setOpen,
  isLoading,
  title = "Reject Invoice",
  description = "Are you sure you want to reject invoice?",
  onReject,
  onSuccess,
  onClose,
}) {
  const handleReject = async (values) => {
    try {
      const { success, message } = await onReject({
        ...data,
        ...values,
      }).unwrap()
      if (success) {
        onSuccess()
        onClose()
        toast.success(message, { id: "toasterMessage" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toasterMessage" })
    }
  }

  const validation = useFormik({
    initialValues: { reason: "" },
    onSubmit: (values) => {
      handleReject(values)
    },
  })

  return (
    <>
      {open && <div className="toast-overlay" />}
      <div
        className="position-fixed top-0 start-50 translate-middle-x p-3 delete-tost"
        style={{ zIndex: "99999" }}
      >
        <Toast isOpen={open} role="alert" className="alert-card-box-wrapper">
          <div className="bg-pattern">
            <img src={BgPatternImage} alt="" />
          </div>
          <ToastBody>
            <div className="delete-card-wrapper">
              <div className="inner-box danger">
                <i className="mdi mdi-close-circle-outline"></i>
              </div>
              <div>
                <h4>{title}</h4>
                {description}
              </div>
              <div className="close-icon" onClick={() => setOpen(false)}>
                <img src={close} alt="" />
              </div>
            </div>

            <Form
              className="form-horizontal"
              onSubmit={(e) => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              <Row>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Reason For Rejection
                    <span className="error">*</span>
                  </Label>
                  <textarea
                    name="reason"
                    type="text"
                    className="form-control"
                    placeholder="Enter the reason for rejection"
                    onChange={validation.handleChange}
                    value={validation.values.reason}
                  />
                  {validation.errors.reason ? (
                    <FormFeedback type="invalid">
                      {validation.errors.reason}
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>

              <div className="mt-3 pt-3 button-wrapper position-relative z-2">
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="cancel"
                >
                  Cancel
                </button>
                <button type="submit" className="delete">
                  {isLoading ? <Spinners /> : "Reject Request"}
                </button>
              </div>
            </Form>
          </ToastBody>
        </Toast>
      </div>
    </>
  )
}

export default RejectConfirmationModel
